import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from '../service/api.service';
import { RequestService } from '../service/request.service';
import { brandFlavor, pageSegment, pageOf } from 'src/app/brand/brand-context';

@Component({
  selector: 'app-bottom-menu',
  templateUrl: './bottom-menu.component.html',
  styleUrls: ['./bottom-menu.component.scss'],
})
export class BottomMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  brandFlavour: string;
  bottomMenu = [];
  component: string;
  webCusSub: Subscription;
  routerSub: Subscription;

  constructor(
    private _requestService: RequestService,
    private apiService: ApiService,
    private _router: Router,
    private host: ElementRef<HTMLElement>
  ) {}

  /**
   * The menu is position: fixed (app.component.scss), so nothing else can
   * see how tall it is. Its rendered height is published as --ui-bottom-nav-h
   * on <html>: body padding keeps content clear of it, .ui-foot and the
   * service-booking bar sit on top of it. 0 while hidden (desktop, or before
   * the items arrive), so pages without a visible menu get no padding.
   */
  private sizeObserver?: ResizeObserver;

  ngAfterViewInit(): void {
    const publish = () => {
      const h = this.host.nativeElement.offsetHeight;
      document.documentElement.style.setProperty('--ui-bottom-nav-h', `${h}px`);
    };
    publish();
    if (typeof ResizeObserver !== 'undefined') {
      this.sizeObserver = new ResizeObserver(publish);
      this.sizeObserver.observe(this.host.nativeElement);
    } else {
      window.addEventListener('resize', publish);
      this.sizeObserver = { disconnect: () => window.removeEventListener('resize', publish) } as any;
    }
  }

  ngOnInit(): void {
    this.component = pageSegment();
    this.brandFlavour = brandFlavor();
    this.getWebCustomer();
    this.routerSub = this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.component = pageOf(event.url);
      }
    });
  }
  ngOnDestroy(): void {
    this.webCusSub?.unsubscribe();
    this.routerSub?.unsubscribe();
    this.sizeObserver?.disconnect();
    document.documentElement.style.removeProperty('--ui-bottom-nav-h');
  }
  getWebCustomer() {
    this.webCusSub = this.apiService.getWebcustomer$.subscribe((res) => {
      if (!res) {
        return;
      }
      this.bottomMenu = res.TemplateData.BottomMenu.Items;
    });
  }

  openUrl(item) {
    if (item.Redirection) {
      this._router.navigate([this._requestService.setUrl(item.Redirection)]);
      return;
    }
    location.href = item.WebLink;
  }
}
